import { productSlider } from "./sliders";
import { intersectionObserver } from "../utils/intersectionObserver";
import { allowedLocales } from "../utils/constants";

const product_hits_block = document.querySelector(".js_product-hits");

const loadHits = () => {
  let locale = document.documentElement.lang;
  if (!(locale in allowedLocales)) {
    locale = allowedLocales.uk;
  }
  fetch(`${locale === "ru" ? "" : "/" + locale}/api/catalog/get-cross-products`)
    .then((response) => response.text())
    .then((html) => {
      product_hits_block.innerHTML = html;
      productSlider();
    })
    .catch((error) => console.error("Error loading hits:", error));
};
export const initLoadHits = () => {
  intersectionObserver({
    root: null,
    rootMargin: "300px",
    threshold: 0,
    target: product_hits_block,
    once: true
  }, loadHits)
}
